// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"598f6598","977":"57e09794"}[chunkId] + ".chunk.js";
};